import React, { useState } from "react";
import "./../../assets/styles/custom/components/register.scss";
import "./../../assets/styles/custom/components/login.scss";
import logo from "./../../assets/images/Group 51.svg";
import moment from "moment";
import firebase from "firebase";
import { Formik, ErrorMessage, Form } from "formik";
import DatePicker from "react-datepicker";
import { Warning } from "../formitems/Index";
import { useAlert } from "react-alert";
import "./Register.css";
function Register({ closeForm }) {
  const alert = useAlert();
  const [Email, setEmail] = useState("");
  const [Password, setPassword] = useState("");
  const [isValidEmail, SetValidEmail] = useState(false);
  const [joinDate, setJoiningDate] = useState(new Date());
  const [errormsg, seterrormsg] = useState("");
  const [user, setuser] = useState({
    ecode: "",
    name: "",
    licence: "",
    phone1: "",
    phone2: "",
    photo: "",
    isdeclared: false,
    pmtaddress: "",
    tempaddress: "",
    isphone1: false,
    ispermanentaddress: false,
    emailpersonal: "",
  });
  const CheckEmailId = () => {
    if (Email !== "" && Password !== "") {
      firebase
        .firestore()
        .collection("registered")
        .where("email", "==", Email)
        .get()
        .then((fetchClient) => {
          if (!(fetchClient.docs.length > 0)) {
            firebase
              .firestore()
              .collection("registration")
              .where("email", "==", Email)
              .where("password", "==", Password)
              .get()
              .then((fetchregisterUser) => {
                if (!(fetchregisterUser.docs.length > 0)) {
                  seterrormsg(
                    "Invalid Credentials.Please contact Administrator."
                  );
                } else {
                  let data = fetchregisterUser.docs[0].data();
                  setuser((prevuser) => {
                    return {
                      ...data,
                      ...prevuser,
                    };
                  });
                  SetValidEmail(true);
                }
              })
              .catch((err) => {
                throw err;
              });
          } else {
            seterrormsg("Email ID has been Already Registered");
          }
        })
        .catch((err) => {
          throw err;
        });
    }
  };

  return (
    <Formik
      initialValues={user}
      enableReinitialize
      validate={(values) => {
        const errors = {};
        if (!values.name) {
          errors.name = "Name is Required";
        }
        if (!values.ecode) {
          errors.ecode = "Employee Code is Required";
        }
        if (!values.licence) {
          errors.licence = "License Number is Required";
        }
        if (!values.pmtaddress) {
          errors.pmtaddress = "Permanent Address is Required";
        }
        if (!values.tempaddress) {
          errors.tempaddress = "Temporary Address is Required";
        }
        if (!values.phone1) {
          errors.phone1 = "Phone Number 1 is Required";
        }
        if (!values.phone2) {
          errors.phone2 = "Phone Number 2 is Required";
        }
        if (!values.emailpersonal) {
          errors.emailpersonal = "Personal EmailID is Required";
        }
        if (!values.isdeclared) {
          errors.isdeclared = "Declaration is Required";
        }
        if (!values.photo) {
          errors.photo = "Photo is Required";
        }
        return errors;
      }}
      onSubmit={(values, { setSubmitting }) => {
        let result = {
          password: Password,
          email: Email,
          joindate: moment(joinDate).format("DD-MM-yyyy"),
          birthdate: moment(Password).format("DD-MM-yyyy"),
          ...values,
        };
        firebase
          .firestore()
          .collection("registered")
          .add(result)
          .then(() => {
            firebase
              .firestore()
              .collection("registration")
              .where("email", "==", Email)
              .get()
              .then(function (querySnapshot) {
                querySnapshot.forEach(function (doc) {
                  doc.ref.delete();
                  alert.show(
                    "Registration Successful.Please contact administrator",
                    {
                      timeout: 3000,
                      type: "success",
                    }
                  );
                  closeForm();
                });
              });
          })
          .catch((err) => {
            console.log(err);
          });
        setSubmitting(false);
      }}
    >
      {({ handleChange, values, setFieldValue }) => (
        <Form>
          <div>
            <div className="register-container">
              <div className="register-box">
                <img className="logo" src={logo} alt="" />
                <div className="register-description">
                  Advanced Aviation Training Management System
                </div>
                <div className="category-title">
                  <span className="client-back" onClick={() => closeForm()}>
                    Log In
                  </span>
                </div>

                <div className="register-title">Register</div>

                <div className="register__input-box">
                  <input
                    disabled={isValidEmail}
                    onChange={(e) => setEmail(e.target.value)}
                    value={Email}
                    name="email"
                    placeholder="Email"
                    className="register-input"
                    type="email"
                  />
                  <input
                    disabled={isValidEmail}
                    onChange={(e) => setPassword(e.target.value)}
                    value={Password}
                    name="password"
                    placeholder="Date of Birth(DD/MM/YYYY)"
                    className="register-input"
                    type="text"
                  />
                  {isValidEmail ? (
                    <div>
                      <div>
                        <p>Employee Code</p>
                        <div className="input-box-container">
                          <input
                            value={values.ecode}
                            name="ecode"
                            onChange={handleChange}
                            placeholder="Enter Employee Code"
                            className="input-box"
                            type="text"
                          />
                          <ErrorMessage
                            className="error"
                            name="ecode"
                            component="div"
                          />
                        </div>

                        <p>Name</p>

                        <div className="input-box-container">
                          <input
                            value={values.name}
                            name="name"
                            onChange={handleChange}
                            placeholder="Enter Name"
                            className="input-box"
                            type="text"
                          />
                          <ErrorMessage
                            className="error"
                            name="name"
                            component="div"
                          />
                        </div>
                        <p>Phone 1</p>

                        <div className="input-box-container">
                          <input
                            value={values.phone1}
                            name="phone1"
                            onChange={handleChange}
                            placeholder="Enter Phone:1 Number"
                            className="input-box"
                            type="text"
                          />
                          <ErrorMessage
                            className="error"
                            name="phone1"
                            component="div"
                          />
                        </div>

                        <p>
                          Phone 2: Same as Phone 1
                          <input
                            style={{ marginLeft: 10 }}
                            onChange={(e) => {
                              setFieldValue("isphone1", e.target.checked);
                              setFieldValue(
                                "phone2",
                                e.target.checked ? values.phone1 : ""
                              );
                            }}
                            value={values.isphone1}
                            name="isphone1"
                            type="checkbox"
                          />
                        </p>

                        <div className="input-box-container">
                          <input
                            onChange={handleChange}
                            value={values.phone2}
                            name="phone2"
                            className="input-box"
                            type="text"
                            placeholder="Enter Phone:2 Number"
                          />
                          <ErrorMessage
                            className="error"
                            name="phone2"
                            component="div"
                          />
                        </div>
                        <p>Personal Email-ID</p>

                        <div className="input-box-container">
                          <input
                            value={values.emailpersonal}
                            name="emailpersonal"
                            onChange={handleChange}
                            placeholder="Enter Personal Email ID"
                            className="input-box"
                            type="text"
                          />
                          <ErrorMessage
                            className="error"
                            name="emailpersonal"
                            component="div"
                          />
                        </div>
                        {/* <p>Date of Birth<span style={{ color: 'orange' }}> Date should be &gt; 1/1/1950 &amp; &lt; 1/1/2002</span></p>

                                                <div className="input-box-container">
                                                    <DatePicker
                                                        selected={birthdate}
                                                        onChange={date => setbirthdate(date)}
                                                        minDate={new Date("01-01-1950")}
                                                        maxDate={new Date("01-01-2002")}
                                                        dateFormat="dd/MM/yyyy"
                                                        placeholderText="Select a date in February 2020"
                                                    />
                                                </div> */}
                        <p>Joining Date</p>

                        <div className="input-box-container">
                          <DatePicker
                            selected={joinDate}
                            dateFormat="dd/MM/yyyy"
                            onChange={(date) => setJoiningDate(date)}
                          />
                        </div>

                        <p>Licence Number</p>
                        <div className="input-box-container">
                          <input
                            name="licence"
                            value={values.licence}
                            onChange={handleChange}
                            placeholder="Enter Licence Number"
                            className="input-box"
                            type="text"
                          />
                          <ErrorMessage
                            className="error"
                            name="licence"
                            component="div"
                          />
                        </div>
                        <p>Permanent Address</p>

                        <div className="input-box-container">
                          <input
                            name="pmtaddress"
                            value={values.pmtaddress}
                            onChange={handleChange}
                            placeholder="Enter Permanent Address"
                            className="input-box"
                            type="text"
                          />
                          <ErrorMessage
                            className="error"
                            name="pmtaddress"
                            component="div"
                          />
                        </div>
                        <p>
                          Temprary Address: Same as Permanent address
                          <input
                            style={{ marginLeft: 10 }}
                            onChange={(e) => {
                              setFieldValue(
                                "ispermanentaddress",
                                e.target.checked
                              );
                              setFieldValue(
                                "tempaddress",
                                e.target.checked ? values.pmtaddress : ""
                              );
                            }}
                            value={values.ispermanentaddress}
                            name="ispermanentaddress"
                            type="checkbox"
                          />
                        </p>

                        <div className="input-box-container">
                          <input
                            type="text"
                            name="tempaddress"
                            value={values.tempaddress}
                            onChange={handleChange}
                            placeholder="Enter Temporary Address"
                            className="input-box"
                          />
                          <ErrorMessage
                            className="error"
                            name="tempaddress"
                            component="div"
                          />
                        </div>
                        <p>Photo</p>

                        <div className="input-box-container">
                          <input
                            id="photo"
                            name="photo"
                            type="file"
                            onChange={(event) => {
                              let reader = new FileReader();
                              reader.readAsDataURL(
                                event.currentTarget.files[0]
                              );
                              reader.onload = function () {
                                setFieldValue("photo", reader.result);
                              };
                              reader.onerror = function (error) {
                                console.log("Error: ", error);
                              };
                            }}
                            className="form-control"
                          />
                          <ErrorMessage
                            className="error"
                            name="photo"
                            component="div"
                          />
                        </div>
                        <p>
                          <input
                            style={{ marginLeft: 10 }}
                            onChange={handleChange}
                            value={values.isdeclared}
                            name="isdeclared"
                            type="checkbox"
                          />{" "}
                          Before registering, Read our terms & conditions and
                          privacy policy, the link is available in the login
                          page. By clicking on register, you agree to AmiAgi
                          terms & conditions and privacy policy. I have read and
                          I agree.
                        </p>
                        <ErrorMessage
                          className="error"
                          name="isdeclared"
                          component="div"
                        />
                      </div>
                    </div>
                  ) : (
                    <div>
                      {errormsg !== "" ? <Warning title={errormsg} /> : null}
                    </div>
                  )}
                </div>
                <div className="mb10">
                  {Email !== "" && isValidEmail ? (
                    <button type="submit" className="submit-button ">
                      Add User
                    </button>
                  ) : (
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        CheckEmailId();
                      }}
                      className="register-submit"
                    >
                      Proceed
                    </button>
                  )}

                  <button
                    onClick={() => closeForm()}
                    className="register-submit register-submit--1"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
}

export default Register;
